import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const useMedia = () =>
  useQuery({ queryKey: ["media"], queryFn: async () => (await api.get("/admin/media")).data, staleTime: 0 });

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/admin/media/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export const useUpload = (onDone) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: uploadImage,
    onSuccess: (item) => { qc.invalidateQueries({ queryKey: ["media"] }); onDone?.(item); },
    onError: (e) => toast.error(formatApiError(e)),
  });
};

export const formatBytes = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
